var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "modal-title" }, [_vm._v(" DISCUSSION ")]),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_discussion.discussion.$error } },
        [
          _c("label", [_vm._v(" Select Discussion ")]),
          _vm._v(" "),
          _c("j-single-select", {
            attrs: {
              options: _vm.list_discussion,
              placeholder: "Choose Discussion",
              label: "name",
              "value-format": "object"
            },
            model: {
              value: _vm.$v.data_discussion.discussion.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_discussion.discussion, "$model", $$v)
              },
              expression: "$v.data_discussion.discussion.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "div",
              { staticClass: "float-to-right" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn gray m__r--5",
                    on: { click: _vm.closeDiscussion }
                  },
                  [_vm._v("\n          Close\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "btn blue",
                    on: { click: _vm.saveDiscussion }
                  },
                  [_vm._v("\n          Save\n        ")]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61a6e2eb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61a6e2eb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/pages-component/jDiscussionSetup.vue
// module id = null
// module chunks = 